import { GoogleAnalyticsEscriptEventName } from '@/hooks/analytics/types';
import useGoogleAnalytics from '@/hooks/analytics/useGoogleAnalytics';
import { LOGIN_ROUTE } from '@/routes/route-paths';
import { emitUIEvent } from '@montugroup/data-collection';
import { Button, Typography } from '@montugroup/design-system';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export const AccountAlreadyExists = () => {
  const { sendGoogleAnalyticsEvent } = useGoogleAnalytics();

  // todo: emitUIEvent is an interim approach until the data collection package is updated with 'Data Events' schema
  useEffect(() => {
    sendGoogleAnalyticsEvent(GoogleAnalyticsEscriptEventName.PRESCRIPTION_SUBMIT_ERROR, {
      error_code: 'existing_user',
    });
    emitUIEvent(
      {
        component_name: 'account_already_exists_screen',
        event_name: 'screenViewed',
        id: 'escript_onboarding_account_already_exists',
        value: 'account already exists screen viewed',
      },
      [],
    );
  }, []);

  return (
    <>
      <Typography variant="subtitle1" fontWeight={600}>
        Welcome back!
      </Typography>
      <Typography data-testid="customer-escript-account-already-exists">Please log in to add this script.</Typography>

      <Button
        component={Link}
        to={LOGIN_ROUTE}
        variant="contained"
        color="primary"
        fullWidth
        data-tracking-id="escript_onboarding_existing_customer_screen_login"
        rel="noopener noreferrer"
      >
        Login
      </Button>
    </>
  );
};
